/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { InsiderTradingPlans } from '../models/insider-trading-plans';
import { IssuerTradingPlansFilters } from '../models/issuer-trading-plans-filters';
@Injectable({
  providedIn: 'root',
})
class InsiderViewTradingPlansService extends __BaseService {
  static readonly getInsiderViewTradingPlansPath = '/insider/view/tradingPlans';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param filter undefined
   * @return returns a insider trading plans
   */
  getInsiderViewTradingPlansResponse(filter: IssuerTradingPlansFilters): __Observable<__StrictHttpResponse<Array<InsiderTradingPlans>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/insider/view/tradingPlans`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InsiderTradingPlans>>;
      })
    );
  }
  /**
   * @param filter undefined
   * @return returns a insider trading plans
   */
  getInsiderViewTradingPlans(filter: IssuerTradingPlansFilters): __Observable<Array<InsiderTradingPlans>> {
    return this.getInsiderViewTradingPlansResponse(filter).pipe(
      __map(_r => _r.body as Array<InsiderTradingPlans>)
    );
  }
}

module InsiderViewTradingPlansService {
}

export { InsiderViewTradingPlansService }
